/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Colors
 */
export interface Colors {
    /**
     * 
     * @type {string}
     * @memberof Colors
     */
    readonly bgColor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Colors
     */
    readonly fgColor?: string | null;
}

/**
 * Check if a given object implements the Colors interface.
 */
export function instanceOfColors(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ColorsFromJSON(json: any): Colors {
    return ColorsFromJSONTyped(json, false);
}

export function ColorsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Colors {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bgColor': !exists(json, 'bgColor') ? undefined : json['bgColor'],
        'fgColor': !exists(json, 'fgColor') ? undefined : json['fgColor'],
    };
}

export function ColorsToJSON(value?: Colors | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

